import axios from 'axios';

import { history } from 'index';
import { Token } from 'models';
import config from 'config/config';


export function request({
  url,
  body,
  method = 'get', // get, head, post, put, patch, delete OR options
  authorize = true
}) {
  let requestConfig = {
    url: config.apiDomain + url,
    method
  };

  if (method === 'get') {
    requestConfig.params = body;
  } else {
    requestConfig.data = body;
  }

  return axios(configureAuth(requestConfig, authorize))
    .catch((error) => {
      if (!error) return Promise.reject();
      if (!error.response) return Promise.reject(error);

      let links = config.serverResponseStatus[error.response.status];

      if (links) {
        links = (typeof(links) === 'string') ? [links] : links;
        if (links.every(link => link !== window.location.pathname)) {
          history.replace(links[0]);
        }
      }
      return Promise.reject(error.response);
    });
}


function configureAuth (requestConfig, authorize = false) {
  let token = Token.get();

  if (!requestConfig.headers) {
    requestConfig.headers = {};
  };

  requestConfig.headers = {
    ...requestConfig.headers,
    'Access-Control-Expose-Headers' : 'location',
    'Content-Type'                  : 'application/json',
    'Authorization'                 : token && authorize ? `bearer ${token}` : ''
  };

  return requestConfig;
}



// WEBPACK FOOTER //
// ./src/utils/request.js